module.exports = __webpack_public_path__ + "img/release.f150fb9c.png";